import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from '../models/product.model';
import { ContactInformation, Customer } from '../models/customer.model';
import { namChatService } from '../service/namChatService';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-product-cart',
  templateUrl: './product-cart.component.html',
  styleUrls: ['./product-cart.component.scss']
})
export class ProductCartComponent implements OnInit {

  @Input() productCart : Product[] =[];
  @Output() closeCart = new EventEmitter<boolean>();
  customer: Customer = new Customer();
  blockedPanel = false;
  constructor(private enquiryService : namChatService, private messageService: MessageService) {
    this.customer.primarySalesContact = new ContactInformation();
   }

  ngOnInit(): void {
    this.setDefaultVariant();
  }

  setDefaultVariant(){
    if(this.productCart && this.productCart.length > 0){
      this.productCart.forEach(
        (prod) => {
          if(prod.selectedVariant){}else{
            if(prod.productVariantMappings && prod.productVariantMappings.length > 0){
              for(var variant of prod.productVariantMappings){
                if(variant.defaultVariant){
                  prod.selectedVariant = variant.variant;
                  break;
                }
              }
            }
          }
        }
      );
    }
  }

  sendEnquiry(){

      if((this.customer.name && this.customer.name != '') && 
    (this.customer.customerEmail && this.customer.customerEmail != '') && 
  (this.customer.phone && this.customer.phone != '')){
    this.blockedPanel = true;
      const request = {
        customerInfo : this.customer,
        productCart: {
          products : this.productCart
        }
      };
     
      this.enquiryService.enquire(request).subscribe(
        (resp) =>
          {
            this.messageService.add({ severity: 'success', summary: 'Success', 
             detail: 'Thanks for enquiring about our product - Your Reference Id is ' + resp.body  });
             this.blockedPanel = false;
            this.closeCart.emit(true);
           
          },
          (error) => {
            this.messageService.add({ severity: 'warn', summary: 'Technical Problem', 
             detail: 'Thanks for enquiring about our product - we will get back to you shortly'  });
             this.blockedPanel = false;
             this.closeCart.emit(true);
            //console.log('Sorry we couldnt contact server', error);
          }
      );
  }else{
    this.messageService.add({ severity: 'warn', summary: 'Contact Details', 
    detail: 'Please fill in your name, email and phone number'  });
  }
  }
  removeFromCart(rowIndex: number){
    this.productCart[rowIndex].inCart = false;
    this.productCart.splice(rowIndex,1);
    this.productCart = [...this.productCart];
  }

}
